var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import { getDateInFormat } from "@domains/utils/reportDates";
import Arrows from "@frameworks/web/components/generic/TableHeaderArrows";
import { addDashIfNullOrUndefined } from "@domains/utils/numberMethods";
import { getSortedData } from "@domains/utils/sort";
var PastIntractionTable = function (props) {
    var _a = __read(useState(props === null || props === void 0 ? void 0 : props.pastIntraction), 2), tableData = _a[0], setTableData = _a[1];
    var _b = __read(useState(false), 2), sortingType = _b[0], setSortingType = _b[1];
    var columnList = [
        {
            title: "Lead ID",
        },
        {
            title: "Lead Date",
        },
        {
            title: "UCC/UPC",
        },
        {
            title: "Type",
        },
        {
            title: "Mode",
        },
        {
            title: "Scheme",
        },
        {
            title: "Pipeline",
            arrows: true,
            key: "amount",
            type: "number",
            applySorting: true,
        },
        {
            title: "Status",
            arrows: true,
            key: "statusName",
            type: "string",
            applySorting: true,
        },
        {
            title: "Interaction Status",
            arrows: true,
            key: "subStatus",
            type: "string",
            applySorting: true,
        },
        {
            title: "Followup Date",
            arrows: true,
            key: "followUpDate",
            type: "string",
            applySorting: true,
        },
        {
            title: "Last Interaction Date",
            arrows: true,
            key: "lastInteractionDate",
            type: "string",
            applySorting: true,
        },
    ];
    var _c = __read(React.useState(), 2), innerTableData = _c[0], setInnerTableData = _c[1];
    var applySortingAccordingKey = function (key, dataType) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            setSortingType(!sortingType);
            result = getSortedData(tableData, sortingType, key, dataType);
            setTableData(result);
            return [2 /*return*/];
        });
    }); };
    useEffect(function () {
        if (props.pastIntraction && props.pastIntraction.length > 0) {
            setTableData(props.pastIntraction);
        }
        else {
            setTableData([]);
        }
    }, [props.pastIntraction]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Table, { className: "lead-table", responsive: true },
            React.createElement("thead", { className: "DMSansMedium_12_500 txt_primaryGrey" },
                React.createElement("tr", null, columnList.map(function (column, idx) {
                    return (React.createElement("th", { key: idx, onClick: function () {
                            return (column === null || column === void 0 ? void 0 : column.applySorting)
                                ? applySortingAccordingKey(column.key, column.type)
                                : null;
                        } }, (column === null || column === void 0 ? void 0 : column.arrows) ? (React.createElement(Arrows, { title: column.title })) : (column.title)));
                }))),
            React.createElement("tbody", { className: "DMSanN_14_400 txt_blackOne1" }, tableData &&
                tableData.length > 0 &&
                tableData.map(function (x, i) {
                    return (React.createElement(React.Fragment, null,
                        React.createElement("tr", { key: i },
                            React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.leadId) ? x === null || x === void 0 ? void 0 : x.leadId : "-"),
                            React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.createdDate)
                                ? getDateInFormat(x === null || x === void 0 ? void 0 : x.createdDate, "DD MMM YY")
                                : "-"),
                            React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.uccCode) ? x === null || x === void 0 ? void 0 : x.uccCode : "-"),
                            React.createElement("td", { className: "ellipsis", title: x === null || x === void 0 ? void 0 : x.custType },
                                React.createElement("span", null, addDashIfNullOrUndefined(x === null || x === void 0 ? void 0 : x.custType))),
                            React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.typeOfContact) ? x === null || x === void 0 ? void 0 : x.typeOfContact : "-"),
                            React.createElement("td", { className: "ellipsis", title: x === null || x === void 0 ? void 0 : x.subCategoryName },
                                React.createElement("span", null, addDashIfNullOrUndefined(x === null || x === void 0 ? void 0 : x.subCategoryName))),
                            React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.amount) ? x === null || x === void 0 ? void 0 : x.amount : "-"),
                            React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.statusName) ? x === null || x === void 0 ? void 0 : x.statusName : "-"),
                            React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.subStatus) ? x === null || x === void 0 ? void 0 : x.subStatus : "-"),
                            React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.followUpDate)
                                ? getDateInFormat(x === null || x === void 0 ? void 0 : x.followUpDate, "DD MMM YY")
                                : "-"),
                            React.createElement("td", null, (x === null || x === void 0 ? void 0 : x.lastInteractionDate)
                                ? getDateInFormat(x === null || x === void 0 ? void 0 : x.lastInteractionDate, "DD MMM YY")
                                : "-"))));
                })))));
};
export default PastIntractionTable;
